// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "h1.special-sauce[data-v-3fa8d380]{position:relative}h1.special-sauce[data-v-3fa8d380]:after{--bg-opacity:1;background-color:#f9bb8e;background-color:rgba(249,187,142,var(--bg-opacity));position:absolute;content:\"\";height:3px;width:50%;bottom:0;left:50%;transform:translateX(-50%)}@media (min-width:768px){.initial[data-v-3fa8d380]{position:static}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
